export default __webpack_public_path__ + "static/media/logo.9874cbd4.png";